// src/thunks/helpThunk.js

import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Define the async thunk action
export const addHelpThunk = createAsyncThunk(
    'help/addHelp',
    async (helpData, { rejectWithValue }) => {
        try {
            // Send the help data to the API
            const response = await axios.post(`${BASE_URL}/help/add`, helpData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            // Return the error response on failure
            return rejectWithValue(error.response?.data?.message || 'Something went wrong');
        }
    }
);
